import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import { store } from "./store";

import Va from "vue-atlas";
import "vue-atlas/dist/index.min.css";

Vue.use(Va, "en");

import VueFire from "vuefire";
import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";




Vue.use(VueFire);
firebase.initializeApp({
  apiKey: "AIzaSyBNQuUqt1qhafSgFI_gQFETKiSs8iq7Fkg",
  authDomain: "malomat-9ac6c.firebaseapp.com",
  databaseURL: "https://malomat-9ac6c.firebaseio.com",
  projectId: "malomat-9ac6c",
  storageBucket: "malomat-9ac6c.appspot.com",
  messagingSenderId: "12165381990"
});

const settings = { /* your settings... */ timestampsInSnapshots: true };
export const db = firebase.firestore();

db.settings(settings);

window.db = db;

Vue.config.productionTip = false;

window.app = null;

firebase.auth().onAuthStateChanged(function (user) {
  if (user) {
    store.dispatch("setCurrentUser", user);
  }

  if (!app) {
    app = new Vue({
      router,
      store,
      render: h => h(App)
    }).$mount("#app");
  }
});
